(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire164e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire164e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("l6fPl", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $f5c66f7974fb7167$export$6503ec6e8aabbaf; }, function (v) { return $f5c66f7974fb7167$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $f5c66f7974fb7167$export$f7ad0328861e2f03; }, function (v) { return $f5c66f7974fb7167$export$f7ad0328861e2f03 = v; });
var $f5c66f7974fb7167$export$6503ec6e8aabbaf;
var $f5c66f7974fb7167$export$f7ad0328861e2f03;
"use strict";
var $f5c66f7974fb7167$var$mapping = new Map();
function $f5c66f7974fb7167$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$f5c66f7974fb7167$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $f5c66f7974fb7167$var$resolve(id) {
    var resolved = $f5c66f7974fb7167$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$f5c66f7974fb7167$export$6503ec6e8aabbaf = $f5c66f7974fb7167$var$register;
$f5c66f7974fb7167$export$f7ad0328861e2f03 = $f5c66f7974fb7167$var$resolve;

});

parcelRegister("eh1Ad", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $a643e1978b14c101$export$bdfd709ae4826697; }, function (v) { return $a643e1978b14c101$export$bdfd709ae4826697 = v; });
var $a643e1978b14c101$export$bdfd709ae4826697;
var $a643e1978b14c101$export$c9e73fbda7da57b6;
var $a643e1978b14c101$export$5a759dc7a1cfb72a;
"use strict";
var $a643e1978b14c101$var$bundleURL = {};
function $a643e1978b14c101$var$getBundleURLCached(id) {
    var value = $a643e1978b14c101$var$bundleURL[id];
    if (!value) {
        value = $a643e1978b14c101$var$getBundleURL();
        $a643e1978b14c101$var$bundleURL[id] = value;
    }
    return value;
}
function $a643e1978b14c101$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $a643e1978b14c101$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $a643e1978b14c101$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $a643e1978b14c101$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$a643e1978b14c101$export$bdfd709ae4826697 = $a643e1978b14c101$var$getBundleURLCached;
$a643e1978b14c101$export$c9e73fbda7da57b6 = $a643e1978b14c101$var$getBaseURL;
$a643e1978b14c101$export$5a759dc7a1cfb72a = $a643e1978b14c101$var$getOrigin;

});

var $e9a42e67fc4113cc$exports = {};


(parcelRequire("l6fPl")).register((parcelRequire("eh1Ad")).getBundleURL("6L7xj"), JSON.parse('["6L7xj","index.4fa318ac.js","eztbB","About.bb8a6514.js","8Pslg","index.89bcab7e.css"]'));

})();
//# sourceMappingURL=index.runtime.196417d7.js.map
